import React from "react";
import { arrayOf, shape, string } from "prop-types";
import Image from "pages/_components/Image";

const ToDoList = ({ items }) => {
    const statusImage = {
        INITIAL: "images/stepCircle.svg",
        WRONG: "images/stepCircleWrong.svg",
        DONE: "images/stepCircleDone.svg",
    };

    return (
        <ul className="list" key={1}>
            {items.map(({ description, status }) => (
                <li className="flex font-size-md" key={description}>
                    <Image src={statusImage[status]} className="svg-icon-small mr-4" />
                    <span>{description}</span>
                </li>
            ))}
        </ul>
    );
};

ToDoList.propTypes = {
    items: arrayOf(
        shape({
            description: string.isRequired,
            status: string.isRequired,
        }),
    ).isRequired,
};

export default ToDoList;
